export { AccountMenuNav4 as default } from '../ui/account-menu/nav4';
